export enum AppSyncError {
  TOKEN_HAS_EXPIRED = 'Token has expired.',
  VALID_AUTHORIZATION_HEADER_NOT_PROVIDED = 'Valid authorization header not provided.',
}
